var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('RecipeFormVue',{attrs:{"recipe-id":_vm.$route.params.id,"deleteButton":"","button-text":"save","title-text":"Update the recipe here"}})}
var staticRenderFns = []

export { render, staticRenderFns }